import * as fragments from './sections/index'

const ALL_SECTIONS: string[] = [
  /* INJECT_TYPE */
  'allergenGuide',
  'dayInTheLifeVideo',
  'locations3UpOpenRoles',
  'photoTextCarousel',
  'accordionItemsWithSideNavigation',
  'contactForm',
  'contentCards',
  'ecommerceItemList',
  'emailSignup',
  'eventDetails',
  'fourOhFour',
  'featureSpotlight',
  'featuredTextBlock',
  'giftCardGrid',
  'giftCardIframe',
  'giftCards',
  'guestServicesHero',
  'homepageHero',
  'homepageHeroLNY',
  'locationsList',
  'mediaBackgroundAndTitle',
  'menuListing',
  'merchandiseListing',
  'merchandiseShowcase',
  'newsletterSignUpSection',
  'orderInquiryForm',
  'pressHighlightListing',
  'reviews',
  'richTextContent',
  'richTextHero',
  'staggeredImages',
  'stats',
  'textAndAccordion',
  'textAndImage',
  'textAndImageHeroWithBreadcrumbs',
  'threeUp',
  'timeline',
  'valuesList',
]

interface FragmentShape {
  fields: string
  fragment: () => string
}

const fragmentsCopy: {
  [key: string]: FragmentShape
} = { ...fragments }

const buildSectionFields = (typeNames: string[]) =>
  typeNames
    .map(typeName => {
      if (fragmentsCopy[typeName as keyof typeof fragmentsCopy]) {
        return `_type == "${typeName}" => { ${fragmentsCopy[typeName as keyof typeof fragmentsCopy].fields} }\n`
      }
    })
    .filter(Boolean)
    .join(',')

export const getFields = () => {
  const sectionFields = buildSectionFields(ALL_SECTIONS)

  return `
    _id,
    _ref,
    section[] {
      ${sectionFields}
    }
  `
}

// Narrowed variant: only inlines fragments for the section types actually present
// on the page being fetched. Keeps the Sanity POST body well under its 300 KB limit
// once the full section set approaches that threshold.
export const getFieldsForTypes = (typeNames: string[]) => {
  const sectionFields = buildSectionFields(typeNames)

  return `
    _id,
    _ref,
    section[] {
      ${sectionFields}
    }
  `
}

/* eslint-disable */
export const fragment: (name: string) => string = (name = 'sections') => {
  return `${name}[] -> {
    ${getFields()}
    }`
}
/* eslint-enable */

const exported = {
  fragment,
  getFields,
  getFieldsForTypes,
}

export default exported
